<template>
    <div>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
                <div class="card bg-secondary shadow border-0">
                    <div class="card-header bg-transparent pb-5">
                            <div class="text-muted text-center mt-2 mb-3">
                                <h1>{{$t('header_1')}}</h1>
                                <h4>{{$t('header_2')}}</h4>
                                <h3 style="color:red">{{$t('header_3')}}</h3>
                            </div>
                        </div>
                    <div class="card-body px-lg-5 py-lg-5">
                        <!-- <div class="text-center text-muted mb-4">
                            <small>Or sign up with credentials</small>
                        </div> -->
                        <div class="text-center text-muted mb-4">
                            {{$t('create_account')}}
                        </div>
                        <ValidationObserver v-slot="{ passes }">
                            <form @submit.prevent="passes(onSubmit)">

                                <base-input :name="$t('first_name')" class="input-group-alternative mb-3"
                                            required
                                            rules="required"
                                            :placeholder="$t('first_name')"
                                            :label="$t('first_name')"
                                            v-model="form.firstname">
                                </base-input>

                                <base-input :name="$t('last_name')" class="input-group-alternative mb-3"
                                            required
                                            rules="required"
                                            :placeholder="$t('last_name')"
                                            :label="$t('last_name')"
                                            v-model="form.lastname">
                                </base-input>

                                {{$t('gender')}} <span style="color:red">*</span><br /><br />

                                <base-radio name="male" class="mb-3" v-model="form.gender">
                                    {{$t('male')}}
                                </base-radio>

                                <base-radio name="female" class="mb-3" v-model="form.gender">
                                    {{$t('female')}}
                                </base-radio>

                                <base-input :name="$t('address')" class="input-group-alternative mb-3"
                                            required
                                            rules="required|min:4"
                                            :placeholder="$t('address')"
                                            :label="$t('address')"
                                            v-model="form.address">
                                </base-input>

                                <base-input :name="$t('phone')" class="input-group-alternative mb-3"
                                            required
                                            rules="required|min:9"
                                            :placeholder="$t('phone')"
                                            :label="$t('phone')"
                                            v-model="form.phone">
                                </base-input>

                                <base-input :name="$t('email')" class="input-group-alternative mb-3"
                                            required
                                            rules="required|email"
                                            :placeholder="$t('email')"
                                            :label="$t('email')"
                                            v-model="form.email">
                                </base-input>

                                <base-input :name="$t('password')" class="input-group-alternative"
                                            :placeholder="$t('password')"
                                            :label="$t('password')"
                                            required
                                            rules="required|min:6"
                                            type="password"
                                            addon-right-icon="display-eye fa fa-eye"
                                            v-model="form.password">
                                </base-input>

                                <!-- <div class="text-muted font-italic">
                                    <small>password strength: <span class="text-success font-weight-700">strong</span></small>
                                </div>

                                <div class="row my-4">
                                    <div class="col-12">
                                        <base-checkbox class="custom-control-alternative">
                                            <span class="text-muted">I agree with the <a href="#!">Privacy Policy</a></span>
                                        </base-checkbox>
                                    </div>
                                </div> -->
                                <div class="text-center">
                                    <base-button nativeType="submit" type="primary" class="my-4">{{$t('create_account')}}</base-button>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6">
                            <router-link :to="'/'+$i18n.locale+'/forget'" class="text-light"><small>{{$t('forget_password')}}</small></router-link>
                    </div>
                    <div class="col-6 text-right">
                        <router-link :to="'/'+$i18n.locale+'/login'" class="text-light">
                            <small>{{$t('login')}}</small>
                        </router-link>
                    </div>
                </div>
            </div>
            <modal :show.sync="modal"
                :gradient="modal_setting.gradient"
                modal-classes="modal-danger modal-dialog-centered">
                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4"></h4>
                    <p>{{modal_setting.alert_text}}</p>
                </div>

                <template slot="footer">
                    <base-button type="link"
                                text-color="white"
                                class="ml-auto"
                                @click="modal = false">
                        {{$t('close')}}
                    </base-button>
                </template>
            </modal>
        </div>
    </div>
</template>
<script>
import { ValidationObserver } from "vee-validate"
import i18n from "@/i18n"
  export default {
    name: 'register',
    components: {
        ValidationObserver
    },
    data() {
      return {
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        form: {
            firstname: '',
            lastname: '',
            gender: '',
            address: '',
            phone: '',
            email: '',
            password: ''
        }
      }
    },
    created () {
        this.checkCurrentLogin()
    },
    updated () {
        this.checkCurrentLogin()
    },
    methods: {
        checkCurrentLogin () {
            if (this.$store.state.token) {
                this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/dashboard')
            }
        },
        modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
        },
        onSubmit () {
            this.$http.post('profile', {
                "email": this.form.email,
                "password": this.form.password,
                "firstname": this.form.firstname,
                "lastname": this.form.lastname,
                "gender": this.form.gender,
                "address": this.form.address,
                "phone": this.form.phone
            })
                .then(request => this.onSubmitSuccessful(request))
                .catch(() => this.onSubmitFailed())
        },
        onSubmitSuccessful (req) {
            if (req.data.code !== '0') {
                this.onSubmitFailed(req)
                return
            }
            // localStorage.token = req.data.data.token
            this.$store.commit('addtoken', req.data.data.token)
            this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/please_verify')
            // window.location.href = '/'+i18n.locale+'/addgym'
        },
        onSubmitFailed (req) {
            // delete localStorage.token
            this.$store.commit('addtoken', '')
            this.modalAlert(req)
        }
    }
  }
</script>
<style>
</style>
